import { LogOutButton } from "../../../auth/components/LogOut"
import { useAuth } from "../../../../context/AuthContext"

export default function ProfilePage() {
    const { session } = useAuth()

    return (
      <article className='bh-100'>
        <h4>Profile</h4>
        <h5>{session?.user?.user_metadata?.full_name || 'Usuario'}</h5>
        <LogOutButton/>
      </article>
    )
  }